import React from "react";
import { Link } from "react-router-dom";
import arrowLeft from "assets/images/icons/arrowWhiteL.svg";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  removeCartItem,
  removePaymentMethod,
  removePromoCode,
} from "features/common/layouts/cartSlice";

const PreviousPageButton = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const handlerRemovePayment = (e) => {
    dispatch(removePromoCode());
    if (location.pathname === "/paymentmethod") {
      dispatch(removeCartItem("Convenience Fee"));
      dispatch(removePaymentMethod());
    }
  };
  return (
    <Link
      to={-1}
      className="d-flex align-items-center text-dark text-decoration-none px-0 mb-3 mb-lg-0"
      onClick={handlerRemovePayment}
    >
      <button className="bg-qw-primary border-0 rounded-circle me-3 p-2 d-flex align-items-center">
        <img src={arrowLeft} alt="arrowLeft.svg" width="20px" height="20px" />
      </button>
      Kembali ke tahap sebelumnya
    </Link>
  );
};

export default PreviousPageButton;
